import { FC } from 'react'

import { ISvgClass } from '../interface'

const SwitchCardIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      fill="none"
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          d="M25 20.062c0 0.667-0.333 0.938-1 0.938h-16v-3.188l-4.688 4.688 4.625 4.625 0.063-3.125h18c1.104 0 2-0.896 2-2v-8.604l-3 3v3.666zM7 11.938c0-0.667 0.333-0.938 1-0.938h16v3.188l4.688-4.688-4.625-4.625-0.063 3.125h-18c-1.104 0-2 0.896-2 2v8.604l3-3v-3.666z"
          fill="inherit"
        />
      </g>
    </svg>
  )
}

export default SwitchCardIcon
